class AdpDefinitionListController {
  constructor() {
    this.name = 'adpDefinitionList';
  }
}

export default AdpDefinitionListController;



// WEBPACK FOOTER //
// ./src/app/components/adpDefinitionList/adpDefinitionList.controller.js